import React, { useState, useEffect } from 'react';
import {
  Button, Dialog, DialogTitle, DialogContent, DialogActions,
  TextField, Typography, CircularProgress
} from '@mui/material';

const ToggleStatusDialog = ({ open, onClose, onConfirm, tenant, loading }) => {
  const [reason, setReason] = useState('');

  useEffect(() => {
    if (open) setReason('');
  }, [open]);

  if (!tenant) return null;

  const isSuspending = tenant.is_active;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>{isSuspending ? 'Suspend School' : 'Activate School'}</DialogTitle>
      <DialogContent>
        <Typography variant="body2" color="text.secondary" mb={2}>
          {isSuspending
            ? `Suspending "${tenant.data?.school_name || tenant.id}" will immediately block all users from logging in or making any requests.`
            : `Activating "${tenant.data?.school_name || tenant.id}" will restore full access for all users immediately.`}
        </Typography>
        {isSuspending && (
          <TextField
            fullWidth
            label="Reason (optional)"
            placeholder="e.g. Non-payment, trial expired..."
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            multiline
            rows={2}
          />
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={loading}>Cancel</Button>
        <Button
          variant="contained"
          color={isSuspending ? 'warning' : 'success'}
          onClick={() => onConfirm(reason)}
          disabled={loading}
        >
          {loading ? <CircularProgress size={20} /> : isSuspending ? 'Suspend' : 'Activate'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ToggleStatusDialog;
